import contactNumberValidator from '../../../form/field-validation/contactNumber';
import {
  chineseMobileNumberShippingToChinaWithTaxEnabled,
} from '../../../form/field-validation/ImportTax/chineseMobileNumberShippingToChinaWithTaxEnabled';
import maxLength from '../../../form/field-validation/max-length';
import minLength from '../../../form/field-validation/minLength';
import required from '../../../form/field-validation/required';

const getContactNumberValidationFunctions = (props) => {
  const rules = [
    chineseMobileNumberShippingToChinaWithTaxEnabled,
    minLength(props.minLength, 'contactNumber'),
    maxLength(props.maxLength, 'contactNumber'),
    contactNumberValidator(props.regexValidation),
  ];
  
  const getRequiredFieldName = () => {
    if (props.isMobileNumber) {
      return 'mobileNumber';
    }
  
    if (props.isBillingContactNumber) {
      return 'billingContactNumber';
    }
    
    return props.isBillingContactNumber ? 'billingContactNumber' : 'contactNumber';
  };
  
  if (props.isRequired) {
    return [required(getRequiredFieldName()), ...rules];
  }
  
  return rules;
};

export default getContactNumberValidationFunctions;
